import { RunSettingsActive } from "./RunSettingsHandler";

export class RunSettingsOverride {
  public override(runSettingsActive: RunSettingsActive) {}
}
